import { Spacing } from '@persona-id/design-tokens';
import { ReactNode } from 'react';
import styled from 'styled-components';

import { FlagIcon } from 'dashboard/components-lib/FlagIcon/FlagIcon';
import { Paragraph } from 'design-system/components/Text';
import { paragraphMixins } from 'design-system/mixins/text';
import { BASE } from 'design-system/variables/spacing';

const Container = styled.div`
  display: grid;
  grid-column-gap: ${Spacing[3]};
  grid-template-columns: ${Spacing[5]} 1fr;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledFlagIcon = styled(FlagIcon)`
  margin-top: ${BASE / 4}px;
`;

const StyledLink = styled.a`
  font-size: ${({ theme }) => theme.text.paragraph.md.fontSize};
`;

const SubTitle = styled.div`
  color: ${({ theme }) => theme.color.text.tertiary};
  ${paragraphMixins.sm}
`;

interface ListMatchEntityProps {
  children?: ReactNode;
  url?: string;
  name?: string;
  flagCode?: string;
}

const ListMatchEntity = ({ children, url, name, flagCode }: ListMatchEntityProps) => {
  return (
    <Container>
      <StyledFlagIcon flagCode={flagCode ?? 'persona'} border={true} />
      <TextContainer>
        {url ? (
          <StyledLink href={url} target='_blank' rel='noreferrer'>
            {name}
          </StyledLink>
        ) : (
          <Paragraph color='secondary'>{name}</Paragraph>
        )}
        <SubTitle>{children}</SubTitle>
      </TextContainer>
    </Container>
  );
};

export default ListMatchEntity;
